module.exports = __webpack_public_path__ + "static/media/wave.cbd04394.svg";